<template>
	
	<div class="guide-tasks-section-button" @click="$router.push('/Guides/Sections/' + section.id)">
		<v-row>
			<v-col>
				<img class="icon" :src="section.icon ?? require('@/assets/round1.png')" />
			</v-col>
		</v-row>
		<v-row class="mt-0">
			<v-col class="title-col">
				{{ section.title }}
			</v-col>
		</v-row>
		<v-row class="mt-0">
			<v-col class="v-col-1 dot-col">
				<img :src="allTasksCompleted ? require('@/assets/green-dot.png') : require('@/assets/orange-dot.png')"/>
			</v-col>
			<v-col class="v-col-7 tasks-col">
				{{completedTaskCount}}/{{ section.tasks.length }} tasks
			</v-col>
			<v-col class="arrow-col">
				<img class="arrow" src="../../assets/arrow-right.png">
			</v-col>
		</v-row>
	</div>
	
</template>

<script>
export default {
	name: "GuideSectionButton",
	props: ['section'],
	data() {
		return {

		}
	},
	computed: {
		completedTaskCount() {
			return this.section.tasks.filter(t => t.completed).length;
		},
		allTasksCompleted() {
			return this.completedTaskCount === this.section.tasks.length;
		}
	},
	methods: {
		onLoad() {
		}
	},
	mounted: function () { this.onLoad(); }
}
</script>

<style scoped>
.guide-tasks-section-button {
	border-radius: 8px;
	padding: 18px;
	border-color: var(--border-color);
	border: 1px solid var(--border-color);
	height: 100%;
	background-color: var(--background-color);
	width: 100%;
	height: 100%;
}

.title-col {
	font-size: 18px;
}

.icon {
	width: 60px;
	background: linear-gradient(230deg, #E7ECF7 16.24%, #EAEDFF 84.93%);
	border-radius: 50%;
}

.arrow-col {
	text-align: right;
	padding-left: 0px;
}

.arrow {
	width: 18px;
}

.tasks-col {
	padding-right: 0px;
	vertical-align: middle !important;
	padding-left: 5px;
}

.dot-col {
	vertical-align: middle !important;
	padding-top: 13px;
	img {
		height: 11px;
	}
}
</style>